import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { VALIDATE_PIN, GENERATE_POS_PIN } from './constants';

export const validatePin = extendRoutine(createRoutine(VALIDATE_PIN), ['RESET']);
export const generatePosPin = extendRoutine(createRoutine(GENERATE_POS_PIN), ['RESET']);
